// See .cache/page-templates after running dev/build
// to understand how this file ends up looking

/* eslint-disable no-unused-vars */
import React from 'react'
import { graphql, navigate } from 'gatsby'
import PageLayout from '../../src/layouts/PageLayout'
import ModalComponent from '../../src/components/Modal'
import AutotunerOneImage from '../../src/../content/images/one.png'

import BlockTextKeyTable from '../../src/components/ACF/BlockTextKeyTable'

const PageTemplate = pageProps => {
	let data
data = pageProps.data.wpPage
	const componentsArray = data.page_components.components || []
	const components = componentsArray.map(component => {
		return {
			name: component.__typename.split('_').pop(),
			data: component
		}
	})

	return (
		<PageLayout
			pageData={data}
			state={pageProps.location.state}
			location={pageProps.location}
			prevPath={pageProps.path}
			pageTitle={data.title}
		>
			<ModalComponent
				image={AutotunerOneImage}
				title="Zelf je auto tunen? Het kan nu!"
				content="Met de Autotuner One heb je volledige controle over je auto’s prestaties. Kies je tuningstages, pas functies aan en optimaliseer je rijervaring waar en wanneer je wilt."
				// emoji="🎁 🎄 🎆"
			></ModalComponent>

			{components.map((component, index) => {

      if (component.name == 'BlockTextKeyTable') {
        return <BlockTextKeyTable {...component.data} key={index} />
      }
    
				return <div key={index}>Error: The component {component.name} was not found</div>
			})}
		</PageLayout>
	)
}

export default PageTemplate


    export const query = graphql`
      query PageQuery2127($id: String!) {
        wpPage(id: {eq: $id}) {
					
		isFrontPage
		title
		header {
			
		heroChoice
		image {
			sourceUrl
			localFile {
				childImageSharp {
					gatsbyImageData(width: 1920, height: 800)
				}
			}
		}
		videoUrl
		height
		fieldGroupName
		backgroundOpacity
		backgroundColor
		pxOrVh
		heroText
  
		}
		seo {
			
		title
		metaDesc
		focuskw
		metaKeywords
		metaRobotsNoindex
		metaRobotsNofollow
		opengraphTitle
		opengraphDescription
		opengraphImage {
			altText
			sourceUrl
			srcSet
		}
		twitterTitle
		twitterDescription
		twitterImage {
			altText
			sourceUrl
			srcSet
		}
		canonical
		cornerstone
		schema {
			articleType
			pageType
			raw
		}
  
		}
  
          
    page_components {
      components {
        __typename
         
 
      ... on WpPage_PageComponents_Components_BlockAccordions {
        
		paddingBottom
		paddingTop
		accordions {
			content
			title
		}
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockAppointmentForm {
        
		paddingTop
		paddingBottom
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockBlog {
        
		buttonText
		link {
			url
			target
			title
		}
		showReadmoreButton
		maximumPostsCount
		paddingTop
		paddingBottom
	
      }
     
 
      ... on WpPage_PageComponents_Components_BlockCallToAction {
        
	callToAction{
		... on WpCta_post {
			id
			title
			postContent {
                buttonText
				imageOverlay
				imageOverlayOpacity
				paddingBottom
				paddingTop
				text
				buttonLink {
					url
				}
				image {
					altText
					sourceUrl
					localFile {
						childImageSharp {
							fluid(quality: 90, maxWidth: 1920) {
								base64
								aspectRatio
								src
								srcSet
								srcWebp
								srcSetWebp
								sizes
							}
						}
					}
				}
			}
		}
	}
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockColumns {
        
		column1
		column2
		paddingBottom
		paddingTop
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockDriversExperience {
        
		buttonText
		link {
			url
			target
			title
		}
		showReadmoreButton
		maximumPostsCount
		paddingTop
		paddingBottom
	
      }
     
 
      ... on WpPage_PageComponents_Components_BlockForm {
        
		formId
		paddingTop
		paddingBottom
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockIcons {
        
		paddingTop
		paddingBottom
		backgroundColor
		iconLeft
		blocks {
			blockIconsIcon
			blockIconsTitle
			blockIconsContent
		}
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockImageTextRow {
        
		paddingTop
		paddingBottom
		blocks {
			image {
				altText
				sourceUrl
				localFile {
				  childImageSharp {
					gatsbyImageData(width: 800)
				  }
				}
			  }
            title
            subtitle
            text
		}
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockPerformanceTable {
        
	paddingBottom
	variant
	paddingTop
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockRecentlyTuned {
        
		buttonText
		link {
			url
			target
			title
		}
		showReadmoreButton
		maximumPostsCount
		paddingTop
		paddingBottom
	
      }
     
 
      ... on WpPage_PageComponents_Components_BlockTextIconBlocks {
        
		text
		active
		paddingBottom
		linkOrButton
		paddingTop
		title
		link {
			url
			target
			title
		}
		linkButtonText
		icons {
			fieldGroupName
			iconTitle
			fontawesomeIconName
		}
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockTextImage {
        
		imagePosition
		linkOrButton
		active
		linkButtonText
		paddingBottom
		paddingTop
		text
		title
		subtitle
		titleColor
		h1Tag
		link {
			url
			target
			title
		}
		backgroundShape
		image {
			altText
			sourceUrl
			localFile {
			  childImageSharp {
				gatsbyImageData(width: 800)
			  }
			}
		  }
	
      }
     
 
      ... on WpPage_PageComponents_Components_BlockTextKeyTable {
        
		linkOrButton
		active
		linkButtonText
		paddingBottom
		paddingTop
		text
		title
		subtitle
		titleColor
		h1Tag
		link {
			url
			target
			title
		}
		backgroundShape
	
      }
     
 
      ... on WpPage_PageComponents_Components_BlockTitle {
        
		backgroundShape
		paddingBottom
		fieldGroupName
		paddingTop
		subtext
		text
		image {
			altText
			sourceUrl
			localFile {
			  childImageSharp {
				gatsbyImageData(width: 800)
			  }
			}
		  }
		imageIsFloating
		bottomOffset
		topOffset
		
  
      }
     
 
      ... on WpPage_PageComponents_Components_BlockTuningLocations {
        
		maximumPostsCount
		paddingTop
		paddingBottom
	
      }
    
      }
    }
  
        }
      }
    `
  
